import React from 'react'
import { ThemeProvider } from '@material-ui/styles'
import { createPriveTheme } from '@prive/prive-core-ui'
import Landing from './Landing'
import AuthContextProvider from './auth/AuthContextProvider'

const App = () => {
    return (
        <ThemeProvider theme={createPriveTheme()}>
            <AuthContextProvider>
                <Landing />
            </AuthContextProvider>
        </ThemeProvider>
    )
}

export default App
